/**
 * @description Gestion des alertes
 */

/* global drupalSettings ModuloTS $get */

(() => {
	// VARS
	const alert = {
		root: document.querySelector('.layout-container'), // Endroid d'insertion de la popin
		url: drupalSettings.yellowstone.alert.urlLookForAlert, // url
		save: drupalSettings.yellowstone.alert.urlRegisterView, // url register
		content: 'data-popin-content', // content register
		close: 'data-popin-close', // attribue de fermeture
	};

	// FONCTIONS

	/**
	 * @description Création de la popin
	 * @param {JSON} data
	 */
	const content = (data) => {
		let popin = '';

		popin += `
        <div class="popin${data.is_alert === 1 ? ' alert' : ''}${
			typeof data.url !== 'undefined' && data.url && data.is_alert === 1
				? ' alert__link'
				: ''
		}" data-id="${data.id}" ${alert.content} aria-labelledby="alert-${
			data.id
		}" aria-modal="true" role="dialog">`;

		if (
			typeof data.thumbnail !== 'undefined' &&
			data.thumbnail &&
			data.is_alert === 0
		) {
			popin += `<div class="popin__img" style="background-image: url('${data.thumbnail}');"></div>`;
		}

		popin += `<button class="popin__close" ${alert.close} aria-describedby="alert-${data.id}"><span class="sr-only">fermer l'alerte</span><i data-icon="cross"></i></button>`;
		popin += `<div class="popin__content" role="document">
              <div class="popin__title">
                ${
					data.is_alert === 1
						? ' <i class="list-group-item__icon btn-icon btn-icon-secondary btn-icon--squared" data-icon="warning"></i>'
						: ''
				}
                <h2 class="popin__title" data-dot="2" id="alert-${data.id}">${
			data.title
		}</h2>
              </div>
              <div class="popin__paragraph">
                ${data.text}
              </div>`;

		if (typeof data.url !== 'undefined' && data.url) {
			popin += `<div class="popin__link"><a class="popin__link__click" href="${
				data.url.link
			}"${data.url.isExternal ? ' target="_blank"' : ''} ${
				alert.close
			}-more>${
				ModuloTS['Find out more']
			}<i data-icon="arrow"></i></a></div>`;
		}

		popin += `</div></div>`;

		return popin;
	};

	/**
	 * @description Insertion de la popin dans le DOM
	 * @param {JSON} data
	 */
	const appendContent = (data) => {
		if (typeof data.title !== 'undefined' && data.title) {
			alert.root.insertAdjacentHTML('afterbegin', content(data));
		}
	};

	/**
	 * @description suppression de l'alerte
	 *
	 */
	const alertContentView = () => {
		const id = document
			.querySelector(`[${alert.content}]`)
			.getAttribute('data-id');
		$get(`${alert.save}?id=${id}`);
		document
			.querySelector(`[${alert.content}]`)
			.classList.add('popin__close__content');
		setTimeout(() => {
			document.querySelector(`[${alert.content}]`).remove();
		}, 1500);
	};

	/**
	 * @description Interaction avec la popin
	 * @param {JSON} data
	 */
	const event = (data) => {
		if (typeof data !== 'undefined' && data) {
			if (document.querySelector(`[${alert.close}]`)) {
				document
					.querySelector(`[${alert.close}]`)
					.addEventListener('click', () => {
						alertContentView();
					});
			}
			if (document.querySelector(`[${alert.close}-more]`)) {
				document
					.querySelector(`[${alert.close}-more]`)
					.addEventListener('click', () => {
						alertContentView();
					});
			}
		}
	};

	// calcule la position du header pour adapter la position de l'alert en fonction
	const setTopPosition = () => {
		const header = document.querySelector('[data-js-header]');
		const popin = document.querySelector('[data-popin-content]') || null;
		const position = header.offsetHeight + header.offsetTop + 20 + 'px';

		if (popin) {
			popin.style.top = position;
		}
	};

	const A11Y = () => {
		const alertContent = document.querySelector('[data-popin-content]');

		if (alertContent) {
			const focusable = alertContent.querySelectorAll(
				'button, [href], [tabindex]:not([tabindex="-1"]'
			);
			const firstFocusableElement = focusable[0]; // get first element to be focused inside modal
			const lastFocusableElement = focusable[focusable.length - 1]; // get last element to be focused inside modal

			alertContent.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') {
					alertContentView();
					document.querySelectorAll('.bypass-links li a')[0].focus();
				} else if (e.shiftKey) {
					// if shift key pressed for shift + tab combination
					if (document.activeElement === firstFocusableElement) {
						lastFocusableElement.focus(); // add focus for the last focusable element
						e.preventDefault();
					}
				} else {
					// if tab key is pressed
					if (e.key !== 'Enter') {
						if (document.activeElement === lastFocusableElement) {
							// if focused has reached to last focusable element then focus first focusable element after pressing tab
							firstFocusableElement.focus(); // add focus for the first focusable element
							e.preventDefault();
						}
					}
				}
			});
		}
	};

	// GO 🚀
	const init = () => {
		if (alert.url) {
			$get(alert.url).then((data) => {
				appendContent(data);
				event(data);
			});

			// positionne l'alert au chargement
			window.addEventListener('load', (e) => {
				setTopPosition();
				A11Y();

				if (!document.querySelector('.cookies')) {
					if (document.querySelector('[data-popin-content]')) {
						document
							.querySelector('[data-popin-content] .popin__close')
							.focus();
					}
				}
			});

			const mutationObserver = new MutationObserver(
				(mutationList, observer) => {
					for (const mutationRecord of mutationList) {
						if (mutationRecord.removedNodes) {
							for (const removedNode of mutationRecord.removedNodes) {
								if (removedNode.id === 'cookieBanner') {
									if (
										document.querySelector(
											'[data-popin-content]'
										)
									) {
										document
											.querySelector(
												'[data-popin-content] .popin__close'
											)
											.focus();
									}
								}
							}
						}
					}
				}
			);

			mutationObserver.observe(document.querySelector('body'), {
				childList: true,
				subtree: true,
				attributes: false,
				characterData: false,
			});

			// positionne l'alert par rapport au comportement du header au scroll
			window.onscroll = () => {
				setTopPosition();
			};
		}
	};

	init();
})();
